import { atom } from 'jotai';

export const isUploadingAttachment = atom(false);
